import * as React from "react";
import TeamsBaseComponent, {ITeamsBaseComponentState} from "msteams-react-base-component";
import {Panel, PanelType, PrimaryButton} from "office-ui-fabric-react";

export interface IRestoreFilePanelState extends ITeamsBaseComponentState {}

export interface IRestoreFilePanelProps {
    ShowRestorePanel: boolean;
    DarkMode: boolean;
    RecycleBinUrl: string;
    HideRestorePanel: () => void;
}

export class RestoreFilePanel extends TeamsBaseComponent<IRestoreFilePanelProps, IRestoreFilePanelState> {
    constructor(props: IRestoreFilePanelProps) {
        super(props);
        this.state = {
            theme: null,
        };
    }

    public render() {
        return (
            <Panel // panel for restoring deleted files
                isOpen={this.props.ShowRestorePanel}
                className={this.props.DarkMode ? "darkMode" : "lightMode"}
                onDismiss={() => this.props.HideRestorePanel()}
                closeButtonAriaLabel="Close"
                customWidth="425px"
                type={PanelType.custom}
                headerText={"Restore File"}
            >
                <hr style={{height: "10px", visibility: "hidden"}} />
                <div>
                    <p>This document has been deleted. Open the recycle bin in a new browser tab to restore it.</p>
                    <br></br>

                    <PrimaryButton
                        onClick={() => window.open(this.props.RecycleBinUrl)}
                        style={{textAlign: "center"}}
                        text="Open Recycle Bin"
                    />
                </div>
            </Panel>
        );
    }
}

export default RestoreFilePanel;
